export const PINK_ANGLE_COLORS = [0xFC99C4, 0xF94F6F];
export const CENTER_OF_CIRCLE = { x: 600, y: 310 };
export const CIRCLE_RADIUS = 200;
export const INITIAL_RADIANS = [Math.PI / 2, -Math.PI / 9];
export const ARC_COLOR_ARR = [0x000000, 0x000000, 0x000000];
export const SLIDERS_COORD = [{ x: 410, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: 60, y: 420 }];
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const RANDOM_BUTTON_COORD = { x: 215, y: 800 }
export const THRESHOLD_RADIAN = Math.PI / 3 * 2;
export const KITE_COLORS = [0xFF0000, 0x0000FF, 0x00FF00, 0xFFFF00];
export const INFO_SLIDER_ASSETS_SLUG = "circle-theorem-7";